module.exports = __webpack_public_path__ + "img/race_460.9dba7293.png";